import { cn } from '@/lib/utils'
import { CircleCheck, CircleAlert, TriangleAlert } from '@/components/icons'

type AlertBadgeVariant = 'valid' | 'warning' | 'error'

interface AlertBadgeProps {
  variant: AlertBadgeVariant
  className?: string
}

const config: Record<AlertBadgeVariant, { bg: string; iconClass: string; Icon: React.ComponentType<{ className?: string }> }> = {
  valid: {
    bg: 'bg-background-positive-subtle',
    iconClass: 'text-content-positive-bold',
    Icon: CircleCheck,
  },
  warning: {
    bg: 'bg-background-notice-subtle',
    iconClass: 'text-background-notice-bold',
    Icon: CircleAlert,
  },
  error: {
    bg: 'bg-background-negative-subtle',
    iconClass: 'text-content-negative-bold',
    Icon: TriangleAlert,
  },
}

export function AlertBadge({ variant, className }: AlertBadgeProps) {
  const { bg, iconClass, Icon } = config[variant]
  return (
    <div
      className={cn(
        'flex items-center justify-center size-[25px] rounded-full shrink-0',
        bg,
        className
      )}
    >
      <Icon className={cn('size-4', iconClass)} />
    </div>
  )
}
